export default __webpack_public_path__ + "static/media/overdue.27fd9c24.png";